import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';

const MultipleLMT = loadable(() => pMinDelay(import('./MultipleLMT'), 300), {
  fallback: <Loading />
});

const AsyncMultipleLMT = props => {
  const pageConfig = {
    headerType: 'full',
    footerType: props.userAgent.device?.type === 'desktop' ? 'full' : 'mobile-none',
    helmet: {
      bodyAttributes: {
        class: `${ props.userAgent.device?.type } bg-grey hide-sticky-navigation`
      },
      link: [
        {
          rel: 'stylesheet',
          type: 'text/css',
          href: '/public/thirdParty/video-js/video-js.min.css'
        }
      ]
    }
  };

  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      <MultipleLMT { ...props } />
    </ApplicationLayout>
  );
};

AsyncMultipleLMT.propTypes = {
  userAgent: PropTypes.object
};

export default AsyncMultipleLMT;
